/**
 * @license
 * Copyright (c) 2017, Barclays Africa Technology, All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file
 */

import { Injectable } from '@angular/core';
import { Http } from '@angular/http'

import { Observable } from "rxjs/Observable";
import { Subscriber } from "rxjs/Subscriber";
// import '@api/rxjs-operators';

import { Widget } from '@api/models/widget';
import { Dashboard } from '@api/models/dashboard';
import { DashboardService } from '../../celine/services/dashboard.service';
import { HttpThresholdService } from '../services/http-threshold.service';

/**
* Service to load dashboard
*/
@Injectable()
export class DashboardThresholdService extends DashboardService {

    // dashboardUrl: string = '/serve/dashboard';
    // new url
    dashboardUrl: string = '/api/dashboard';

    /**
     * Create the new instance of DashboardThresholdService
     * @param http The instance of Http
     */
    constructor(protected http: HttpThresholdService) {
        super(http);
    }

    /**
      * @return Return the observable array of Dashboard menus
      */
    getDashboardMenu(): Observable<Dashboard[]> {
        return Observable.empty<Dashboard[]>();
        // return this.http.get(`${this.dashboardUrl}`)
        //     .map((response: any) => response.json())
        //     .map((dashboards: any) => dashboards ? dashboards : []);
    }

    /**
     * @param user The url to get the Dashboard's content
     * @return Return dashboard from backend and translate it into the array of Widgets
     */
    getDashboard(url: string): Observable<Widget[]> {
        return Observable.empty<Widget[]>();
        // return this.http.get(`${url}`)
        //     .map((response: any) => response.json())
        //     .map(response => response.widgets);
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/threshold/services/dashboard-threshold.service.ts